import { __assign } from "tslib";
import { AppEventType, createWixLogger } from '..';
export var createOneInboxEngagementLogger = function (props) {
    var logEngagementEvent = function (_a) {
        var data = _a.data, engagementName = _a.engagementName, engagedComponent = _a.engagedComponent, _b = _a.engagedSubComponent, engagedSubComponent = _b === void 0 ? '' : _b;
        props.logger.logEvent({
            type: AppEventType.ONE_INBOX_USER_ENGAGEMENT_EVENT,
            data: {
                tenant_id: props.tenantId,
                user_id: props.currentUser.id,
                role_id: props.currentUser.roleId,
                lang: props.lang,
                data: data ? JSON.stringify(data) : '',
                engaged_component: engagedComponent,
                engaged_sub_component: engagedSubComponent,
                engagement_name: engagementName,
            }
        });
    };
    var ticketList = function (data) {
        return logEngagementEvent(__assign({ engagedComponent: 'Ticket List' }, data));
    };
    var ticketItem = function (data) {
        return logEngagementEvent(__assign({ engagedComponent: 'Ticket Item' }, data));
    };
    var views = function (data) {
        return logEngagementEvent(__assign({ engagedComponent: 'Views' }, data));
    };
    var ticketPage = function (data) {
        return logEngagementEvent(__assign({ engagedComponent: 'Ticket Page' }, data));
    };
    var bulkActions = function (data) {
        return logEngagementEvent(__assign({ engagedComponent: 'Bulk Actions' }, data));
    };
    return {
        ticketList: ticketList,
        views: views,
        ticketPage: ticketPage,
        bulkActions: bulkActions,
        ticketItem: ticketItem,
    };
};
export var createOneInboxLogger = function (webBiLogger) {
    var logger = createWixLogger(false, webBiLogger);
    return function (data) { return logger.appOneInboxAMemberClientEngagement(data); };
};
//# sourceMappingURL=one-inbox.js.map